(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.LFDeliveryPromise = api;
})(typeof window === 'undefined' ? this : window, function () {
  'use strict';
  var months = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
  function iso(d) { return [d.getFullYear(), String(d.getMonth()+1).padStart(2,'0'), String(d.getDate()).padStart(2,'0')].join('-'); }
  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function parseRange(text, now) {
    var matches = Array.from(clean(text).matchAll(/\b(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\.?\s+(\d{1,2})(?:st|nd|rd|th)?(?:,?\s+(20\d{2}))?\s*[-–—]\s*(?:(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\.?\s+)?(\d{1,2})(?:st|nd|rd|th)?(?:,?\s+(20\d{2}))?\b/gi));
    if (matches.length !== 1) return null;
    var match = matches[0];
    var m1 = months.indexOf(match[1].slice(0,3).toLowerCase());
    var m2 = match[4] ? months.indexOf(match[4].slice(0,3).toLowerCase()) : m1;
    var y1 = match[3] ? Number(match[3]) : now.getFullYear();
    if (!match[3] && m1 < now.getMonth()) {
      if (now.getMonth() >= 10 && m1 <= 1) y1++;
      else return null;
    }
    var y2 = match[6] ? Number(match[6]) : y1 + (m2 < m1 ? 1 : 0);
    var start = new Date(y1,m1,Number(match[2]));
    var end = new Date(y2,m2,Number(match[5]));
    var day = new Date(now.getFullYear(),now.getMonth(),now.getDate());
    if (start.getMonth() !== m1 || start.getDate() !== Number(match[2]) || end.getMonth() !== m2 || end.getDate() !== Number(match[5])) return null;
    if (start < day || end < start || (end-day)/86400000 > 180) return null;
    return {start:iso(start),end:iso(end),yearInferred:!match[3] || !match[6]};
  }
  function selectMessage(lines, title) {
    lines = lines.map(clean).filter(Boolean);
    var dated = lines.filter(function(s){return /\b(?:arriv|deliver|ship|dispatch)/i.test(s) && /\d/.test(s);});
    var quick = /quick[\s-]*ship/i.test(title);
    if (dated.length === 1) return dated[0];
    var chosen = dated.filter(function(s){return quick ? /quick[\s-]*ship/i.test(s) : /standard/i.test(s);});
    return chosen.length === 1 ? chosen[0] : null;
  }
  function build(lines, variant, now, timezone) {
    var text = selectMessage(lines, variant.title);
    var dates = text && parseRange(text, now);
    var type = text && /arriv|deliver/i.test(text) ? 'arrival' : text && /ship|dispatch/i.test(text) ? 'dispatch' : null;
    if (!dates || !type) return {_lf_promise_status:'needs_review',_lf_promise_version:'1',_lf_promise_variant:String(variant.id)};
    var expires = new Date(now.getFullYear(),now.getMonth(),now.getDate()+1);
    var props = {
      _lf_promise_status:'captured',_lf_promise_version:'1',_lf_promise_source:'C-EDD rendered widget',
      _lf_promise_variant:String(variant.id),_lf_promise_type:type,
      _lf_promise_start:dates.start,_lf_promise_end:dates.end,
      _lf_promise_captured_at:now.toISOString(),_lf_promise_valid_until:expires.toISOString(),
      _lf_promise_timezone:timezone || 'unknown',_lf_promise_year_inferred:String(dates.yearInferred),
      _lf_promise_displayed_text:text
    };
    return props;
  }
  function merge(existing, snapshot) {
    var result = Object.assign({},existing || {});
    Object.keys(result).forEach(function(k){if(k.indexOf('_lf_promise_')===0)delete result[k];});
    return Object.assign(result,snapshot);
  }
  function pageContext() {
    if (typeof document === 'undefined') return null;
    var node = document.getElementById('lf-delivery-promise-config');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }
  function snapshot(id) {
    var config = pageContext();
    var variant = config && config.variants.find(function(v){return String(v.id)===String(id);});
    if (!variant) return null;
    var widget = document.querySelector('.delivery-widget__container .msg__container');
    var lines = [];
    if (widget) {
      lines = Array.from(widget.children).map(function(e){return e.textContent;}).filter(function(s){return clean(s);});
      if (!lines.length) lines = [widget.textContent];
    }
    return build(lines,variant,new Date(),Intl.DateTimeFormat().resolvedOptions().timeZone);
  }
  function properties(id, existing) {
    var data = snapshot(id);
    return data ? merge(existing,data) : existing || {};
  }
  function syncForm(form) {
    var id = form.querySelector('[name="id"]');
    if (!id) return;
    form.querySelectorAll('[data-lf-promise]').forEach(function(e){e.remove();});
    var data = snapshot(id.value);
    if (!data) return;
    Object.keys(data).forEach(function(key){
      var input=document.createElement('input');input.type='hidden';input.name='properties['+key+']';
      input.value=data[key];input.setAttribute('data-lf-promise','1');form.appendChild(input);
    });
  }
  function init() {
    if (!pageContext()) return;
    document.addEventListener('submit',function(e){if(e.target.matches('form[action*="/cart/add"]'))syncForm(e.target);},true);
    document.addEventListener('click',function(e){
      var target=e.target.closest('button, input[type="submit"], .shopify-payment-button');
      var form=target && target.closest('form[action*="/cart/add"]');if(form)syncForm(form);
    },true);
    document.addEventListener('change',function(e){var form=e.target.closest('form[action*="/cart/add"]');if(form)syncForm(form);},true);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);
    var widget=document.querySelector('.delivery-widget__manual, .delivery-widget__theme');
    if(widget)new MutationObserver(function(){document.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);}).observe(widget,{childList:true,subtree:true,characterData:true});
  }
  if (typeof document !== 'undefined') {
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  }
  return {parseRange:parseRange,selectMessage:selectMessage,build:build,merge:merge,properties:properties};
});
